import { Options, Vue } from 'vue-class-component'
import { VueCookieNext } from 'vue-cookie-next'
import { host } from '@/api/Conf';
import {MD5} from '../api/md5'
interface DocumentType {
  DocID: string
}
import Header from '@/components/Header.vue';
@Options({
  components: {
  Header
  }
})
export default class Home extends Vue {
  items: [] = []
  custName = ''
  public pad(number: number, length: number): string {
    let str = '' + number;
    while (str.length < length) {
      str = '0' + str
    }
    return str
  }
  public async login(pin: string, email: string): Promise<boolean> {
    const md5 = MD5(pin);
    const prefix1 = md5.substring(0,8)!.match(/.{1,2}/g).reverse().join('') ?? ''
    const prefix2 = md5.substring(8,12).match(/.{1,2}/g).reverse().join('')
    const prefix3 = md5.substring(12,16).match(/.{1,2}/g).reverse().join('') 
    const prefix4 = md5.substring(16,20)
    const prefix5 = md5.substring(20,32)
    const enc = `${prefix1}-${prefix2}-${prefix3}-${prefix4}-${prefix5}`
    const response = await this.axios.post(`${host}/api/v1/query`,{
      "q": `Exec USP_AR_Customers_CRMLogin @Email='${email}', @PIN='${enc}'`,
      "plain": true
    });
    if(response.data !=null && typeof(response.data) !='undefined' && response.data !=''){
      return true;
    } else{
      return false;
    }
  }
  public logout(): void {
    VueCookieNext.removeCookie('CustID')
    VueCookieNext.removeCookie('CustName')
    window.location.reload()
  }
  public toYYYYMMDDHHMMSS(date: Date): string {
    const yyyy = date.getFullYear().toString();
    const MM = this.pad(date.getMonth() + 1, 2);
    const dd = this.pad(date.getDate(), 2);
    const hh = this.pad(date.getHours(), 2);
    const mm = this.pad(date.getMinutes(), 2)
    const ss = this.pad(date.getSeconds(), 2)
    return `${dd}/${MM}/${yyyy} ${hh}:${mm}:${ss}`
  }
  public parseToDateString(timestamp: string): string {
    const date = new Date(timestamp)
    return this.toYYYYMMDDHHMMSS(date)
  }
  public async changePassword() {
    const oldPassword = prompt("Please enter your old password:");
    const email = VueCookieNext.getCookie('Email');
    const response = await this.login(oldPassword, email);
    if(response){
      try {
        const newPassword = prompt("Please enter your new password:");
      const md5 = MD5(newPassword);
      const prefix1 = md5.substring(0,8)!.match(/.{1,2}/g).reverse().join('') ?? ''
      const prefix2 = md5.substring(8,12).match(/.{1,2}/g).reverse().join('')
      const prefix3 = md5.substring(12,16).match(/.{1,2}/g).reverse().join('') 
      const prefix4 = md5.substring(16,20)
      const prefix5 = md5.substring(20,32)
      const enc = `${prefix1}-${prefix2}-${prefix3}-${prefix4}-${prefix5}`
      await this.axios.post(`${host}/api/v1/query`,{
        "q": `Exec USP_AR_Customers_ChangePINEx @CustomerID=${VueCookieNext.getCookie('CustID')}, @PIN='${enc}'`,
        "plain": true
      });
      alert('Password change successfully');
        this.logout()
      } catch (error) {
        alert(error)
      }
    } else {
      alert('Please enter a valid password');
    }

  }
  public async mounted(): Promise<void> {
    if(!VueCookieNext.getCookie('CustID')){
      window.location.href = '/login'
    }else{
      const response = await this.axios.post(`${host}/api/v1/query`, {
        "q": `Exec USP_AR_SORecomMaster_QueryList @CustomerID = ${VueCookieNext.getCookie('CustID')}`,
        "plain": false
      });
      this.items = response.data
      this.custName = VueCookieNext.getCookie('CustName')
    }
  }
  public goto(item: DocumentType): void {
    window.location.href = `/recom/${item.DocID}`
  }
}